import { createAxios } from "./axiosHttpMarconi";

export const paletsHubsService = {
  getPaletsHubs,
  deletePaletHub,
  postPaletHub,
  updatePaletHub,
  getPaletHubById,
};

function getPaletsHubs(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/palets-hubs`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0";
  }
  urlPath += getUrlPath(filters);
  return axios.get(urlPath);
}

function getUrlPath(filters) {
  let urlPath = "";
  if (filters && filters.cp) {
    urlPath += `&cp=${filters.cp}`;
  }
  if (filters && filters.nombre) {
    urlPath += `&nombre=${filters.nombre}`;
  }
  return urlPath;
}

function deletePaletHub(hubId) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/palets-hubs/${hubId}`;
  return axios.delete(urlPath);
}

function postPaletHub(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/palets-hubs`;
  return axios.post(urlPath, request);
}

function updatePaletHub(id, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/palets-hubs/${id}`;
  return axios.put(urlPath, body);
}
function getPaletHubById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/palets-hubs/${id}`;
  return axios.get(urlPath);
}
